<template>
  <div class="slideBox stream-conversion" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Stream Conversion
      </h1>
      <h2>Homepage</h2>
      <p>Generierte Sessions &gt; 60 Sek. aus Sitzungen</p>
    </div>

    <div class="centerBlock">
      <div class="svg website"></div>
      <div class="arrow stream-conversion-total">
        <div class="big value">
          <i-count-up
            :start="0"
            :end="totalValueEnd"
            :duration="countDuration"
            :options="options"
          ></i-count-up>
        </div>
      </div>
      <div class="svg stream"></div>
    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'

export default {
  name: 'stream-conversion',
  components: {
    ICountUp
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        suffix: '%'
      }
    }
  },
  mounted () {
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_stream_conversion'

    /* total value */
    const totalValueURL = urlPart + '-last_7_days'
    this.axios.get(totalValueURL).then((response) => {
      this.totalValueEnd = parseInt(_.head(response.data.results).percent)
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/stream-conversion.vue